// extracted by mini-css-extract-plugin
module.exports = {"key":"hotkey_key_14dCr","keypress":"hotkey_keypress_2s_xx","low":"hotkey_low_1TZDa","lower":"hotkey_lower_3oims"};